import { ajaxRetry } from '../../lib-api/ajaxRetry';
import {
  AccountDialogType,
  GenerateReportAsyncResponse,
  GenerateReportResponse,
  ReportAccountsResponse,
  ReportDescriptionResponse,
  ReportType,
} from '../models/report';
import { base, createApiURL, ResponseObj } from '../../lib-api/services/base';
import { RefreshableItem } from '../../models/refreshableItem';

export type BundledFlowParameters = {
  reportTypes: ReportType[];
  refreshableItems: RefreshableItem[];
  accountDialogType: AccountDialogType;
};

export const describe = ({
  reportTypes,
  refreshableItems,
  accountDialogType,
}: BundledFlowParameters): Promise<ResponseObj<ReportDescriptionResponse>> => {
  const queryParams = new URLSearchParams({
    requestedReportTypes: reportTypes.join(','),
    requestedRefreshItems: refreshableItems.join(','),
    requestedAccountDialogType: accountDialogType,
  });

  return ajaxRetry<ReportDescriptionResponse>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/user-report-bundles/describe?${queryParams}`),
  });
};

export const getAccounts = ({
  reportTypes,
  refreshableItems,
  accountDialogType,
}: BundledFlowParameters): Promise<ResponseObj<ReportAccountsResponse>> => {
  const queryParams = new URLSearchParams({
    requestedReportTypes: reportTypes.join(','),
    requestedRefreshItems: refreshableItems.join(','),
    requestedAccountDialogType: accountDialogType,
  });

  return ajaxRetry<ReportAccountsResponse>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/user-report-bundles/account-dialog-options?${queryParams}`),
  });
};

export type GenerateReportPayload = {
  requestedReportTypes: ReportType[];
  accounts?: string[];
  customerReferenceId?: string;
  externalReference?: string;
  requestedRefreshItems?: string[];
  requestedAccountDialogType?: AccountDialogType;
};

export type GenerateReportAsyncPayload = {
  requestedReportTypes: ReportType[];
  accounts?: string[];
  customerReferenceId?: string;
  externalReference?: string;
  requestedRefreshItems?: string[];
  requestedAccountDialogType?: AccountDialogType;
  credentialIds: string[];
};

export const generateReport = (
  payload: GenerateReportPayload,
  idempotencyKey: string
): Promise<ResponseObj<GenerateReportResponse>> => {
  return ajaxRetry<GenerateReportResponse>({
    data: JSON.stringify(payload),
    headers: {
      ...base.headers(),
      'Idempotency-Key': idempotencyKey,
    },
    method: 'POST',
    url: createApiURL(`/api/v1/user-report-bundles`),
  });
};

export const generateReportsAsync = (
  payload: GenerateReportAsyncPayload,
  idempotencyKey: string
): Promise<ResponseObj<GenerateReportAsyncResponse>> => {
  return ajaxRetry<GenerateReportAsyncResponse>({
    data: JSON.stringify(payload),
    headers: {
      ...base.headers(),
      'Idempotency-Key': idempotencyKey,
    },
    method: 'POST',
    url: createApiURL(`/api/v1/user-report-bundles/async`),
  });
};
